module.exports = __webpack_public_path__ + "static/fonts/329-CAI978.c7a2a358.ttf";